import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL      = "https://xycpzokrmhkqvcrltbij.supabase.co";
// Publishable key — replaces the legacy anon (JWT) key. Safe to embed in the
// browser bundle, same as the old anon key was.
const SUPABASE_ANON_KEY = "sb_publishable_xUft2O0A-6rzuLHtK7KdLA_i2l0ExT8";

// The only client — RLS policies (see supabase/migrations) are the real
// access-control boundary. The service-role key never ships to the browser;
// the one operation that genuinely needs it (inviting a user) goes through
// the invite-user Edge Function instead.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { autoRefreshToken: true, persistSession: true, detectSessionInUrl: true }
});
